import { CountryMasterService } from "@/api/services/masterService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Define types for Country
interface Country {
    id: string;
    countryName: string;
    status: any;
    swiftCode: string;

}

// Define state type
interface CountryMasterState {
  loading: boolean;
  CountryList: Country[];
  error?: string;
}

// Initial state with type safety
const initialState: CountryMasterState = {
  loading: false,
  CountryList: [],
  error: undefined,
};

// ✅ Fixed Async thunk with proper return type
export const fetchCountryMaster = createAsyncThunk<
  Country[], 
  void, 
  { rejectValue: string }
>(
  "Country/fetchCountryMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await CountryMasterService.getall();

      // If API returns { data: Country[] }, extract `data`
      return response.data ? response.data : response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch Country data");
    }
  }
);

// Create slice with strong typing
const CountryMasterSlice = createSlice({
  name: "CountryMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountryMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchCountryMaster.fulfilled, (state, action: PayloadAction<Country[]>) => {
        state.CountryList = action.payload;
        state.loading = false;
      })
      .addCase(fetchCountryMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// Export reducer
export default CountryMasterSlice.reducer;
